module.exports = __webpack_public_path__ + "img/ep-planche-a-tapas.d28a426f.jpg";